const TextInputField = ({
  label,
  name,
  value,
  compulsory = false,
  formField = true,
  posField = false,
  error,
  ...props
}) => (
  <div
    className={`form-group ${formField ? "mt-3" : posField ? "mt-1" : "mt-2"}`}
  >
    {(formField || posField) && (
      <label className={`${posField ? "label-small" : "label"}`}>{label}</label>
    )}
    <div className="flex">
      <input
        type="text"
        className={`${formField ? "input" : "input-small"}`}
        name={name}
        value={value}
        {...props}
      />
      {compulsory && <span className="label-imp">*</span>}
    </div>
    {error && (formField || posField) ? (
      <p className="label-error">{error}</p>
    ) : (
      error && <p className="label-error-pos">{error}</p>
    )}
  </div>
);

export default TextInputField;
